import { useDispatch } from "react-redux";
import { openModal, closeModal } from "../store/features/modalSlice";

export const useGlobalModal = () => {
  const dispatch = useDispatch();

  const showModal = (modalType: string, props: any) => {
    dispatch(openModal({ modalType, props }));
  };

  const hideModal = () => {
    dispatch(closeModal());
  };

  return { showModal, hideModal };
};
